import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ListEagerProviderDirective, ListPaginatedProviderDirective } from 'shared/modules/list/providers';
import { MaterialModule } from 'shared/modules/material/material.module';
import { SkeletonModule } from 'shared/modules/skeleton/skeleton.module';
import {
  ListActionsDirective,
  ListBodyDirective,
  ListComponent,
  ListContainerDirective,
  ListHeadDirective,
} from './list.component';

@NgModule({
  declarations: [
    ListComponent,
    ListEagerProviderDirective,
    ListPaginatedProviderDirective,
    ListActionsDirective,
    ListBodyDirective,
    ListHeadDirective,
    ListContainerDirective,
  ],
  exports: [
    ListComponent,
    ListEagerProviderDirective,
    ListPaginatedProviderDirective,
    ListActionsDirective,
    ListBodyDirective,
    ListHeadDirective,
    ListContainerDirective,
  ],
  imports: [
    TranslateModule,
    CommonModule,
    MaterialModule,
    SkeletonModule,
    ScrollingModule,
  ],
})
export class ListModule {
}
